import React, { useRef, useEffect } from 'react';

const TableScrollWrapper = ({ children, stickyColumnWidth = 170 }) => {
    const scrollContainerRef = useRef(null);

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        const handleTableInputFocus = (e) => {
            const parentCell = e.target.closest('td, th');
            if (!parentCell || parentCell.cellIndex === 0) return;
            
            // CSS scroll-margin handles the offset automatically
            parentCell.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'start'
            });
        };

        scrollContainer.addEventListener('focusin', handleTableInputFocus, true);
        return () => scrollContainer.removeEventListener('focusin', handleTableInputFocus, true);
    }, []);

    return (
        <div 
            ref={scrollContainerRef}
            className="table-scroll-wrapper"
            style={{ overflowX: "auto", width: "100%" }}
        >
            {children}
        </div>
    );
};

export default TableScrollWrapper;



// WEBPACK FOOTER //
// ./src/components/commonModals/TableScrollWrapper.js